export default __webpack_public_path__ + "static/artistBox-dr-nova-e-4884fd43f59c98381cd52d593a186a37.png";